var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid d-flex align-items-center justify-content-center"},[_c('button',{staticClass:"btn btn-secondary text-white mt-5",attrs:{"type":"button"},on:{"click":_vm.goLockers}},[_vm._v("Przejdź do Collectomate")])])}
var staticRenderFns = []

export { render, staticRenderFns }